<div class="page-head-section">
  <p>National Technical Officials</p>
</div>

<div class="filters" style="margin-bottom: 30px">
  <input
    class="input-search"
    id="myInput"
    placeholder="Search by name"
    [(ngModel)]="name"
    (input)="FilterByName($event.target.value)"
  />

  <div class="drop-area res-area">
    <p-dropdown
      placeholder="Filter by type"
      [options]="typeList"
      [(ngModel)]="typeFilter"
      (onChange)="filterByType($event)"
    ></p-dropdown>
  </div>

  <button (click)="ClearFilters()" class="clear-filter">Clear Filters</button>
</div>

<div class="archers-content">
  <div class="ui-g archer-head-row">
    <div class="ui-g-7">
      <p class="heading-archer" style="text-align: left">Name</p>
    </div>
    <!-- <div class="ui-g-3">
      <p class="heading-archer">Association</p>
    </div> -->
    <div class="ui-g-5">
      <p class="heading-archer">Type</p>
    </div>
    <!-- <div class="ui-g-4">
      <p class="heading-archer">Type</p>
    </div> -->
  </div>

  <div *ngFor="let data of JudgesData" class="ui-g archer-content-row">
    <div class="ui-g-7">
      <div class="player-name" style="text-align: left">
        <!-- <img src="assets/icons/player.png" alt="" /> -->

        <img
          *ngIf="data?.profileImage !== '' || data?.profileImage !== null"
          class="profile-img"
          [src]="global.basePathImage +data?.profileImage"
          alt=""
        />

        <img
          *ngIf="data?.profileImage === '' || data?.profileImage === null"
          class="profile-img"
          src="assets/icons/player.png"
          alt=""
        />

        <p class="content-archer" style="text-transform: capitalize">
          {{ data?.fullName }}
        </p>
      </div>
    </div>
    <!-- <div class="ui-g-3">
      <p class="content-archer">{{ data?.memberAssociation.type }}</p>
    </div> -->
    <div class="ui-g-5">
      <div class="gender">
        <p class="content-archer">{{ data?.certificateLevel }}</p>
      </div>
    </div>
    <!-- <div class="ui-g-4">
        <p class="content-archer">{{ data?.memberAssociation.type }}</p>
      </div> -->
  </div>
</div>
